import { render } from "./PlanesList.vue?vue&type=template&id=6648dd14&scoped=true"
import script from "./PlanesList.vue?vue&type=script&lang=js"
export * from "./PlanesList.vue?vue&type=script&lang=js"

import "./PlanesList.vue?vue&type=style&index=0&id=6648dd14&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6648dd14"]])

export default __exports__